import { config } from '../helpers/constants';
import { createApiAxios } from './createApiAxios';

const caCpGwApi = createApiAxios(config.API_GW_BASE_URL);
const caCpGwApiV2 = createApiAxios(config.API_GW_BASE_URL, '/v2');

export { caCpGwApi, caCpGwApiV2 };
